import React from 'react';
import { ReferenceField } from 'react-admin';

import FullNameField from '../components/FullNameField';

const UserReferenceField = props => {
  return ( props.record && props.record.user ?
        <ReferenceField source="user.id" reference="users" {...props}>
            <FullNameField />
        </ReferenceField>
    : <>-</>
)};

UserReferenceField.defaultProps = {
    source: 'user.id',
    label: 'resources.users.fields.user',
    addLabel: true,
};

export default UserReferenceField;
